/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Rate_LimitsInputs */

const en_directory_agent_readiness_check_rate_limits = /** @type {(inputs: Directory_Agent_Readiness_Check_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rate limits`)
};

const zh_directory_agent_readiness_check_rate_limits = /** @type {(inputs: Directory_Agent_Readiness_Check_Rate_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速率限制`)
};

/**
* | output |
* | --- |
* | "Rate limits" |
*
* @param {Directory_Agent_Readiness_Check_Rate_LimitsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_rate_limits = /** @type {((inputs?: Directory_Agent_Readiness_Check_Rate_LimitsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Rate_LimitsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_rate_limits(inputs)
	return zh_directory_agent_readiness_check_rate_limits(inputs)
});
export { directory_agent_readiness_check_rate_limits as "directory.agent_readiness.check.rate_limits" }